import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './InventoryTransfers.frontend.types'

@Injectable({ providedIn: 'root' })
export class InventoryTransfers_create_inventory_transfer_intermediaryService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { inventory_transfer_id: number, project_id?: number, account_id?: number, sequence: number }): Promise<{ is_success: boolean, error?: string, id: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventory_transfer_id)) {
      missingRequiredInParams.push('\'inventory_transfer_id\'');
    }
    if (isNil(inParams.sequence)) {
      missingRequiredInParams.push('\'sequence\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/functions/create_inventory_transfer_intermediary`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

